import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { withRouter } from 'react-router-dom';
import swal from 'sweetalert';
import { logout } from '../actions/userActions';

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch (e) {
    return null;
  }
};

const AuthVerify = (props) => {
  const dispatch = useDispatch();
  const { history } = props;

  useEffect(() => {
    const unlisten = history.listen(() => {
      let userInfo = null;
      try {
        userInfo = JSON.parse(localStorage.getItem('userInfo'));
      } catch (e) {
        userInfo = null;
      }

      if (userInfo) {
        const decodedJwt = parseJwt(userInfo.token);
        // console.log(decodedJwt);
        if (decodedJwt && decodedJwt.exp * 1000 < Date.now()) {
          swal(
            'Error!',
            'Upps! your current session expired. Please relogin to continue.',
            'error'
          ).then((value) => {
            dispatch(logout());
          });
        }
      }
    });

    return unlisten;
  }, [history, dispatch]);

  return <div></div>;
};

export default withRouter(AuthVerify);
